module.exports = "/_next/static/images/primary-circle-828x828px-c3967c0e4af9099ce519bd80d5104b65.png";